/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_LoadingInputs */

const en_users_loading = /** @type {(inputs: Users_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading users…`)
};

const pt_br2_users_loading = /** @type {(inputs: Users_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando usuários…`)
};

/**
* | output |
* | --- |
* | "Loading users…" |
*
* @param {Users_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_loading = /** @type {((inputs?: Users_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_loading(inputs)
	return pt_br2_users_loading(inputs)
});